module.exports = __webpack_public_path__ + "static/img/reporticon9.6bf3087b.png";